let uploadUrl = ''
if(process.env.VUE_APP_GRALIC === 'test' || process.env.VUE_APP_GRALIC === 'development' || process.env.VUE_APP_GRALIC === 'production') {
	uploadUrl = 'http://up-z1.qiniup.com/'
}
export default uploadUrl